export const toRecord = (value: unknown): Record<string, unknown> | null => {
    if (typeof value !== 'object' || value === null || Array.isArray(value)) {
        return null;
    }

    return value as Record<string, unknown>;
};

export const toNumberValue = (value: unknown): number | null => {
    if (typeof value === 'number' && Number.isFinite(value)) {
        return value;
    }

    if (typeof value === 'string') {
        const parsed = Number(value);
        return Number.isFinite(parsed) ? parsed : null;
    }

    return null;
};

export const toProbabilityValue = (value: unknown): number | null => {
    const numericValue = toNumberValue(value);
    if (numericValue === null || numericValue < 0) {
        return null;
    }

    if (numericValue <= 1) {
        return numericValue;
    }

    if (numericValue <= 100) {
        return numericValue / 100;
    }

    return null;
};

export const toStringValue = (value: unknown): string | null => {
    if (typeof value !== 'string') {
        return null;
    }

    const trimmedValue = value.trim();
    return trimmedValue.length > 0 ? trimmedValue : null;
};
